import type { RouteRecordRaw } from 'vue-router';

export const MONTHLY_SETTLEMENT_ROUTER: RouteRecordRaw[] = [
  {
    path: '/adjustment/month',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/adjustment/month/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/adjustment/month/views/List.vue'),
        name: 'Monthly Settlement List',
        meta: {
          title: '월정산목록',
        },
      },
    ],
  },
];
